module.exports = __webpack_public_path__ + "static/media/client-stack.c701fce9.png";